/* OLENOVA product page, 2026-09-21. Loaded by sections/main-product.liquid.

   - keeps the price inside the buy button and the sticky bar in step with the

     price element Shopify re-renders on variant change

   - sticky buy bar on phones: never sets a variant, never posts to the cart,

     it only clicks the theme's own button[name=add]

   - stock note under the button follows the button's disabled state

   - Size guide link, arrows on the main picture (gallery progress line kept, hidden by CSS)

   No window scroll listener anywhere. */

(function () {

  'use strict';

  var info = document.querySelector('product-info[id^="MainProduct-"]');

  if (!info) return;

  var sectionId = info.dataset.section;

  var bar = document.querySelector('[data-olv-sticky]');

  var barBtn = bar && bar.querySelector('[data-olv-sticky-btn]');

  var barPrice = bar && bar.querySelector('[data-olv-sticky-price]');

  var sizeTouched = !bar || bar.dataset.hasSize !== 'true';



  function addBtn() { return info.querySelector('button[name="add"]'); }

  function priceEl() { return document.getElementById('price-' + sectionId); }



  /* ---- price sync -------------------------------------------------- */

  function readPrice() {

    var el = priceEl();

    var box = el && el.querySelector('.price');

    if (!box || el.classList.contains('hidden')) return null;

    var onSale = box.classList.contains('price--on-sale');

    var now = box.querySelector(onSale ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular');

    var was = onSale ? box.querySelector('.price__sale s.price-item--regular') : null;

    if (!now) return null;

    return { now: now.textContent.trim(), was: was ? was.textContent.trim() : '' };

  }

  function paintPrice(target, p, gap) {

    if (!target) return;

    while (target.firstChild) target.removeChild(target.firstChild);

    if (!p) return;

    if (p.was) {

      var s = document.createElement('s');

      s.textContent = p.was;

      target.appendChild(s);

      if (gap) target.appendChild(document.createTextNode(' '));

    }

    var n = document.createElement('span');

    n.textContent = p.now;

    target.appendChild(n);

  }

  function syncStock() {

    var n = info.querySelector('[data-olv-stock]');

    var b = addBtn();

    if (n) n.hidden = !b || b.disabled;

  }

  function syncPrice() {

    var p = readPrice();

    var b = addBtn();

    paintPrice(b && b.querySelector('[data-olv-btnprice]'), p, false);

    paintPrice(barPrice, p, true);

  }



  /* ---- sticky bar state -------------------------------------------- */

  function sizeFieldset() {

    var sets = info.querySelectorAll('variant-selects fieldset, variant-selects .product-form__input');

    for (var i = 0; i < sets.length; i++) {

      var l = sets[i].querySelector('legend, label.form__label');

      if (l && /size/i.test(l.textContent) && sets[i].getClientRects().length) return sets[i];

    }

    return null;

  }

  function paintBar() {

    if (!barBtn) return;

    var b = addBtn();

    if (!b || b.disabled) {

      barBtn.disabled = true;

      barBtn.textContent = 'Sold out';

      return;

    }

    barBtn.disabled = false;

    barBtn.textContent = sizeTouched ? 'Add to bag' : 'Select a size';

  }

  function touchIfSize(e) {

    if (sizeTouched) return;

    var t = e.target;

    if (!t || !t.closest) return;

    var fs = sizeFieldset();

    if (fs) {

      if (fs.contains(t) && t.closest('input, select, label')) { sizeTouched = true; paintBar(); }

    }

  }

  info.addEventListener('change', touchIfSize, true);

  info.addEventListener('click', touchIfSize, true);



  if (bar && barBtn) {

    /* Products whose picker is drawn by an app (no theme size fieldset):

       any change of the form's variant id counts as the shopper's choice. */

    var idInput = info.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');

    if (idInput) {

      idInput.addEventListener('change', function () {

        if (!sizeTouched && !sizeFieldset()) { sizeTouched = true; paintBar(); }

      });

    }



    barBtn.addEventListener('click', function () {

      var b = addBtn();

      if (!b || b.disabled) return;

      if (!sizeTouched) {

        var target = sizeFieldset() || info.querySelector('variant-selects') || b;

        target.scrollIntoView({ block: 'center', behavior: 'smooth' });

        return;

      }

      b.click();

    });



    bar.hidden = false;

    document.body.classList.add('olv-pdp-body');



    var mainInView = false;

    var blocked = false;

    function show() { bar.classList.toggle('is-on', !mainInView && !blocked); }

    if ('IntersectionObserver' in window) {

      var io = new IntersectionObserver(function (entries) {

        mainInView = entries[entries.length - 1].isIntersecting;

        show();

      });

      var watched = null;

      var watch = function () {

        var b = addBtn();

        if (b && b !== watched) { if (watched) io.unobserve(watched); io.observe(b); watched = b; }

      };

      watch();

      /* keep clear of the cookie banner and any open drawer or modal */

      var consent = function () {

        var c = document.querySelector('#shopify-pc__banner, .shopify-pc__banner__dialog');

        var open = c && c.getClientRects().length > 0 && getComputedStyle(c).visibility !== 'hidden';

        var drawer = document.querySelector('cart-drawer.active, .drawer.active, details[open].menu-drawer-container, .product-media-modal[open]');

        blocked = !!open || !!drawer;

        show();

      };

      consent();

      new MutationObserver(consent).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'open', 'style'] });

    } else {

      bar.classList.add('is-on');

    }

  }



  /* ---- react to the theme re-rendering price and button ------------- */

  var mo = new MutationObserver(function () { syncPrice(); syncStock(); paintBar(); if (typeof markSizeGuide === 'function') markSizeGuide(); });

  var pe = priceEl();

  if (pe) mo.observe(pe, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });

  var ab = addBtn();

  if (ab) mo.observe(ab, { attributes: true, attributeFilter: ['disabled'] });

  syncPrice();

  syncStock();

  paintBar();



  /* ---- Size guide link --------------------------------------------- */

  /* the fit badge keeps its own Size guide link unless the one on the Size

     line is really on screen (app-drawn pickers hide the theme picker) */

  function markSizeGuide() {

    var a = info.querySelector('[data-olv-sizeguide]');

    info.classList.toggle('olv-pdp-has-sg', !!a && a.getClientRects().length > 0);

  }

  markSizeGuide();

  setTimeout(markSizeGuide, 1500);

  setTimeout(markSizeGuide, 4000);

  info.addEventListener('click', function (e) {

    var a = e.target.closest && e.target.closest('[data-olv-sizeguide]');

    if (!a) return;

    var d = document.querySelector(a.getAttribute('href'));

    if (!d) return;

    e.preventDefault();

    d.open = true;

    d.scrollIntoView({ behavior: 'smooth', block: 'start' });

  });



  /* ---- rating line: tap scrolls to the reviews on this page ------------ */

  var rating = info.querySelector('[data-olv-rating]');

  if (rating) {

    rating.addEventListener('click', function (e) {

      var w = document.querySelector('#olv-reviews, .jm-review-widget, .jdgm-widget, #judge-me-reviews, [id^="shopify-block-"][id*="judge"]');

      if (!w) return;

      e.preventDefault();

      w.scrollIntoView({ behavior: 'smooth', block: 'start' });

    });

  }



  /* ---- arrows on the main picture (theme gallery) ---------------------- */

  (function () {

    var gallery = info.querySelector('media-gallery');

    var viewer = gallery && gallery.querySelector('slider-component[id^="GalleryViewer"]');

    var list = viewer && viewer.querySelector('.product__media-list');

    if (!gallery || !viewer || !list) return;

    var desktop = window.matchMedia('(min-width: 750px)');

    function items() {

      return Array.prototype.filter.call(list.querySelectorAll('.product__media-item'), function (li) {

        if (li.classList.contains('is-active')) return true;

        /* on desktop the theme hides the non-active pictures, on phones all pictures sit in the slider */

        return desktop.matches ? getComputedStyle(li).display !== 'none' || true : li.getClientRects().length > 0;

      });

    }

    function current(all) {

      var active = all.filter(function (li) { return li.classList.contains('is-active'); })[0];

      if (active && desktop.matches) return all.indexOf(active);

      var best = 0, bestD = Infinity, L = list.getBoundingClientRect().left;

      all.forEach(function (li, i) { var d = Math.abs(li.getBoundingClientRect().left - L); if (d < bestD) { bestD = d; best = i; } });

      return best;

    }

    function go(step) {

      var all = items();

      if (all.length < 2) return;

      var i = (current(all) + step + all.length) % all.length;

      var id = all[i].dataset.mediaId;

      if (typeof gallery.setActiveMedia === 'function') gallery.setActiveMedia(id, false);

      else all[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });

    }

    function arrow(dir) {

      var b = document.createElement('button');

      b.type = 'button';

      b.className = 'olv-gal-arrow olv-gal-arrow--' + dir;

      b.setAttribute('aria-label', dir === 'prev' ? 'Previous picture' : 'Next picture');

      b.innerHTML = dir === 'prev'

        ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>'

        : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';

      b.addEventListener('click', function (e) { e.preventDefault(); go(dir === 'prev' ? -1 : 1); });

      viewer.appendChild(b);

    }

    if (list.querySelectorAll('.product__media-item').length > 1) { arrow('prev'); arrow('next'); }

  })();



  /* ---- gallery progress line (phones) -------------------------------- */

  function makeProg(count, after) {

    var prog = document.createElement('div');

    prog.className = 'olv-pdp-prog';

    prog.setAttribute('aria-hidden', 'true');

    var thumb = document.createElement('i');

    thumb.style.width = (100 / count) + '%';

    prog.appendChild(thumb);

    after.insertAdjacentElement('afterend', prog);

    return thumb;

  }

  if (window.matchMedia('(max-width: 749px)').matches) {

    var tries = 0;

    var themeDone = false;

    var setup = function () {

      /* Rio app gallery: follow the slide that carries the active class */

      var rioWrap = info.querySelector('.rio-media-gallery #pwzrswiper-wrapper');

      if (rioWrap) {

        var slides = rioWrap.querySelectorAll('.pwzrswiper-slide');

        var host = info.querySelector('.rio-media-gallery');

        if (slides.length > 1 && host && !host.parentElement.querySelector(':scope > .olv-pdp-prog')) {

          var t1 = makeProg(slides.length, host);

          var follow = function () {

            var all = rioWrap.querySelectorAll('.pwzrswiper-slide');

            for (var i = 0; i < all.length; i++) {

              if (all[i].classList.contains('pwzrswiper-slide-active')) { t1.style.width = (100 / all.length) + '%'; t1.style.transform = 'translateX(' + i * 100 + '%)'; break; }

            }

          };

          new MutationObserver(follow).observe(rioWrap, { subtree: true, attributes: true, attributeFilter: ['class'], childList: true });

          follow();

        }

        return;

      }

      /* theme slider */

      var list = info.querySelector('.product__media-list.slider');

      if (!themeDone && list && list.getClientRects().length) {

        themeDone = true;

        var count = list.querySelectorAll('.product__media-item').length;

        if (count > 1) {

          var t2 = makeProg(count, list.closest('slider-component') || list);

          t2.style.transition = 'none';

          var ticking = false;

          list.addEventListener('scroll', function () {

            if (ticking) return;

            ticking = true;

            requestAnimationFrame(function () {

              var max = list.scrollWidth - list.clientWidth || 1;

              t2.style.transform = 'translateX(' + (list.scrollLeft / max) * (count - 1) * 100 + '%)';

              ticking = false;

            });

          }, { passive: true });

        }

      }

      /* the Rio app may still arrive and replace the theme gallery */

      if (++tries < 20) setTimeout(setup, 300);

    };

    setup();

  }

})();



/* Photo colour swatches, drawn by the theme itself. Added 2026-09-23.

   The ProductWiz Rio app stopped being served to the storefront, which left

   every colour option as plain text pills. This paints the theme's own pills

   with that colour's variant photo, so swatches no longer depend on an app.

   If the app ever comes back it draws its own tiles and olv-pdp.css hides

   these pills, so the two cannot fight. */

(function () {

  var VISUAL = ['color', 'colour', 'style', 'configuration', 'primary color', 'variant'];

  var SIZE = 62;

  var cache = null;



  function styleOnce() {

    if (document.getElementById('olv-sw-style')) return;

    var s = document.createElement('style');

    s.id = 'olv-sw-style';

    s.textContent =

      'product-info .product-form__input--pill label.olv-sw{' +

      'width:' + SIZE + 'px;height:' + SIZE + 'px;min-width:0;padding:0 !important;' +

      'border:1px solid var(--olv-hair,#dcdad4);border-radius:var(--olv-r,2px);' +

      // olv-pdp.css sets "background:none" on these labels, and that shorthand

      // resets background-size, so these three need !important to survive it.

      'background-color:#fff !important;background-size:contain !important;' +

      'background-repeat:no-repeat !important;background-position:center !important;' +

      'font-size:0 !important;line-height:0;color:transparent;overflow:hidden}' +

      'product-info .product-form__input--pill input[type=radio]:checked+label.olv-sw{' +

      'border-color:var(--olv-ink,#171717);box-shadow:0 0 0 1px var(--olv-ink,#171717)}' +

      'product-info .product-form__input--pill input[type=radio]:focus-visible+label.olv-sw{' +

      'outline:2px solid var(--olv-pine,#0f6b5f);outline-offset:2px}' +

      'product-info .product-form__input--pill:has(label.olv-sw){display:flex;flex-wrap:wrap;gap:8px}' +

      'product-info .product-form__input--pill:has(label.olv-sw) .form__label{flex:0 0 100%}' +

      // On a variant change the theme inserts a FRESH <variant-selects> and only then removes

      // the stale one, so for ~300ms both are in the DOM and the colour row appears twice.

      // With text pills that was a thin flicker; with 62px photo tiles it is a whole second row

      // appearing and vanishing. The new node is inserted FIRST (measured 2026-09-23), so any

      // variant-selects that FOLLOWS another one is the stale copy on its way out.

      'product-info variant-selects ~ variant-selects{display:none !important}';

    document.head.appendChild(s);

  }



  function productHandle() {

    var c = document.querySelector('link[rel="canonical"]');

    var path = c ? c.getAttribute('href') : window.location.pathname;

    var m = String(path).match(/\/products\/([^/?#]+)/);

    return m ? m[1] : null;

  }



  function sized(src) {

    if (!src) return null;

    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=160';

  }



  function buildMap(p) {

    var names = (p.options || []).map(function (o) {

      return typeof o === 'string' ? o : (o && o.name);

    });

    var idx = -1;

    for (var i = 0; i < names.length; i++) {

      if (VISUAL.indexOf(String(names[i]).trim().toLowerCase()) !== -1) { idx = i; break; }

    }

    if (idx === -1) return null;

    var images = {};

    (p.variants || []).forEach(function (v) {

      var value = v.options && v.options[idx];

      if (!value || images[value]) return;

      var src = v.featured_image && v.featured_image.src;

      if (src) images[value] = sized(src);

    });

    return Object.keys(images).length ? { option: names[idx], images: images } : null;

  }



  function paint() {

    if (!cache) return 0;

    var painted = 0;

    var pills = document.querySelectorAll('product-info .product-form__input--pill input[type="radio"]');

    Array.prototype.forEach.call(pills, function (input) {

      var src = cache.images[input.value];

      if (!src) return;

      var label = input.nextElementSibling;

      if (!label || label.tagName !== 'LABEL') return;

      painted++;

      if (label.getAttribute('data-olv-sw') === src) return;

      label.setAttribute('data-olv-sw', src);

      label.setAttribute('title', input.value);

      if (!label.getAttribute('aria-label')) label.setAttribute('aria-label', input.value);

      label.classList.add('olv-sw');

      label.style.backgroundImage = 'url("' + src + '")';

    });

    return painted;

  }



  function start() {

    var info = document.querySelector('product-info');

    if (!info) return;

    var h = productHandle();

    if (!h) return;

    styleOnce();

    fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' } })

      .then(function (r) { return r.ok ? r.json() : null; })

      .then(function (p) {

        if (!p) return;

        cache = buildMap(p);

        if (!cache) return;

        paint();

        new MutationObserver(function () { paint(); })

          .observe(info, { childList: true, subtree: true });

      })

      .catch(function () { });

  }



  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', start);

  } else {

    start();

  }

})();

